import type { IntRange } from 'type-fest';
import { CustomBooleanField } from './custom-boolean-field';
import { CustomCurrencyFloatField } from './custom-currency-float-field';
import { CustomDateField } from './custom-date-field';
import { CustomDateTimeField } from './custom-date-time-field';
import { CustomFloatField } from './custom-float-field';
import { CustomNumberField } from './custom-number-field';
import { CustomSelectField } from './custom-select-field';
import { CustomTextField } from './custom-text-field';
import type { CustomFieldProps } from './types';

import type { JSX } from 'react';

interface CustomField extends CustomFieldProps {
  kind: IntRange<0, 9, 1> & number;
}
const CustomFieldObject = {
  0: CustomTextField,
  1: CustomDateField,
  2: CustomDateTimeField,
  3: CustomBooleanField,
  4: CustomNumberField,
  5: CustomFloatField,
  6: CustomCurrencyFloatField,
  7: CustomSelectField,
  8: CustomSelectField,
} as const satisfies Record<number, (props: CustomField) => JSX.Element>;

export function CustomField({ kind, ...rest }: CustomField) {
  const Comp = CustomFieldObject[kind];
  if (!Comp) {
    return null;
  }
  return <Comp {...rest} />;
}

interface CustomFieldWrapperProps {
  children: React.ReactNode;
}

export function CustomFieldWrapper({ children }: CustomFieldWrapperProps) {
  return (
    <div className='flex w-full flex-col gap-2 not-first:*:mt-2'>
      {children}
    </div>
  );
}
